/* 🤖 this file was generated by svg-to-ts */
export const matIconFlag: {
  name: 'flag';
  data: string;
} = {
  name: 'flag',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12.36 6 .4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"/></svg>`
};
